<form [formGroup]="form">

  <app-input-group>
    <label appLabel>{{ 'conversionFactorModal.applyTo' | translate }}</label>
    <select appSelect formControlName="applyTo" [collection]="applyToOptions"></select>
  </app-input-group>

  @if (form.get('applyTo')?.value) {

    <app-input-group>
      <label appLabel>{{ 'conversionFactorHistory.validFrom' | translate }}</label>
      <input appInput type="datetime-local" formControlName="validFrom" />
    </app-input-group>

    <app-input-group>
      <label appLabel>{{ 'conversionFactorHistory.validTo' | translate }}</label>
      <input appInput type="datetime-local" formControlName="validTo" />
    </app-input-group>

    <div class="py-2 text-sm font-semibold">
      {{ 'meterFrame.conversionFactor' | translate }}
    </div>

    <label class="ec-toggle-label text-sm font-normal">
      {{ 'conversionFactorModal.mirrorValues' | translate }}
      <app-toggle [formControl]="mirrorValues"></app-toggle>
    </label>

    <app-input-group>
      <label appLabel>A14</label>
      <input appInputNumber formControlName="conversionFactorA14" [decimals]="4" [selectOnFocus]="true" />
    </app-input-group>

    <app-input-group>
      <label appLabel>A23</label>
      <input appInputNumber formControlName="conversionFactorA23" [decimals]="4" [selectOnFocus]="true" />
    </app-input-group>

    <app-input-group>
      <label appLabel>R12</label>
      <input appInputNumber formControlName="conversionFactorR12" [decimals]="4" [selectOnFocus]="true" />
    </app-input-group>

    <app-input-group>
      <label appLabel>R34</label>
      <input appInputNumber formControlName="conversionFactorR34" [decimals]="4" [selectOnFocus]="true" />
    </app-input-group>

  }

</form>
